module.exports = __webpack_public_path__ + "static/img/b17.260d98f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/b17.png
// module id = /rEj
// module chunks = 0